import LoaclStorage from "../manager/local_storage";


export default class SdkStorage{


    static setLoginToken(value : string){
        //测试号不存
        if (!Number(value) || Number(value) > 1000) {

            cc.log(" setLoginToken ");            
            LoaclStorage.setItem("loginToken",value);    
        } else {
            this.clearLoginToken();
        }
    }

    static getLoginToken(){
        cc.log(" getLoginToken ");
        return LoaclStorage.getItem("loginToken");
    }

    static clearLoginToken(){
        cc.log(" clearLoginToken ");
        LoaclStorage.delete("loginToken");
    }
}
